import { SelectRadioField } from '@resurs-internal/mui';
import { SelectFieldOption } from '@resurs-internal/mui/components/SelectField/SelectFieldOption';
import { ComponentProps, FC } from 'react';

import { FieldValidationProps } from '../../hooks/useFieldValidation';
import InputField from '../InputField/InputField';
import ValidationError from '../ValidationError/ValidationError';

type RadioFieldProps = {
    name: string;
    options: SelectFieldOption[];
    validation?: FieldValidationProps;
};

// @resurs-internal/mui's SelectRadioField type extends MUI's RadioGroupProps (which has `name`), but its .d.ts
// imports it from '@mui/material/RadioGroup/RadioGroup' -- a subpath @mui/material no longer exposes via its
// package.json "exports" map since the v7 upgrade. skipLibCheck hides the resulting resolution failure, so the
// extends clause silently drops and `name` disappears from the type, even though the library still forwards it
// correctly to RadioGroup at runtime. Cast until @resurs-internal/mui fixes the import path.
const RadioGroupField = SelectRadioField as FC<ComponentProps<typeof SelectRadioField> & { name: string }>;

const RadioField = (props: RadioFieldProps) => {
    return (
        <InputField {...props} radioFieldoOptions={props.options}>
            <RadioGroupField
                name={props.name}
                options={props.options?.map((field) => ({
                    id: field.id,
                    label: field.label,
                }))}
            />
            <ValidationError fieldName={props.name} />
        </InputField>
    );
};

export default RadioField;
